import script from "./ChatInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatInput.vue?vue&type=script&setup=true&lang=js"

import "./ChatInput.vue?vue&type=style&index=0&id=3576be82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3576be82"]])

export default __exports__